<template>

	<div class="report_container full" v-loading="loading">
		<vxe-grid :id="reportName+'_list'" class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
			@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
		</vxe-grid>
		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
		<exportTable :ref="exportRef" />

		<vxe-modal size="mini" v-model="detailShow" width="1200" height="800" show-footer destroy-on-close transfer
			:lock-scroll="false" :showHeader="true" title="详情" :loading="detailloading">
			<template #default>
				<vxe-table :scroll-y="{enabled: false}" border :row-config="{isCurrent: true, isHover: true}"
					:data="detailData" show-footer :span-method="spanMethod" :footer-method="footerMethod"
					max-height="650" :footer-cell-class-name="footerCellClassName">
					<vxe-column field="year" title="年份">
						<template #default="{row}">
							{{row.year+'年'}}
						</template>
					</vxe-column>
					<vxe-column field="quarter" title="季度">
						<template #default="{row}">
							{{quarterMap[row.quarter-1]}}
						</template>
					</vxe-column>
					<vxe-column field="month" title="月份">
						<template #default="{row}">
							{{row.month+'月'}}
						</template>
					</vxe-column>
					<vxe-column field="day" title="日">
						<template #default="{row}">
							{{row.day+'日'}}
						</template>
					</vxe-column>
					<vxe-column field="invoicecompany" title="开票公司">
						<template #default="{row}">
							{{systemMethods.getcompany(row.invoicecompany)}}
						</template>
					</vxe-column>
					<vxe-column field="invoiceattr" title="发票类型">
						<template #default="{row}">
							{{systemMethods.getEmunValue('invoiceattr',row.invoiceattr)}}
						</template>
					</vxe-column>
					<vxe-column field="num" title="开票数量"></vxe-column>
					<vxe-column field="num2" title="未开票数量"></vxe-column>
					<vxe-column field="invoicepreamount" title="开票金额"></vxe-column>
					<vxe-column field="invoicepreamount2" title="未开票金额"></vxe-column>
				</vxe-table>
			</template>
			<template #footer>

			</template>
		</vxe-modal>


	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	import exportTable from '@_system/components/export/index.vue'
	export default {
		mixins: [reportBase],
		name: 'report',
		props: {

		},
		data() {
			return {
				detailconfig: {
					year: null,
					quarter: null,
					month: null,
				},
				detailShow: false,
				detailData: [],
				footerField: [{
					type: 'seq',
					field: 'year',
					title: '总计',
				}, {
					type: 'field',
					field: 'invoicepreamount',
					toFixed: 4
				}, {
					type: 'field',
					field: 'num',
					toFixed: 2
				}, {
					type: 'field',
					field: 'num2',
					toFixed: 2
				}, {
					type: 'field',
					field: 'invoicepreamount2',
					toFixed: 4
				}],
				reportName: 'invoiceoutput',
				windowName: '开票统计表',
				showFooter: true,
				exportRef: Math.random(),
				loading: false,
				detailloading: false,
				quarterMap: ['第一季度', '第二季度', '第三季度', '第四季度']
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.systemMethods = window.systemMethods
		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig, columns, gridOptions) {
				columns.forEach((item) => {
					if (item.field == 'year' || item.field == 'quarter' || item.field == 'month') {
						item.slots = {
							default: ({
								row,
								column
							}) => {
								let value = row[column.property]
								if (column.property == 'year') {
									value += '年'
								}
								if (column.property == 'quarter') {

									value = this.quarterMap[value - 1]
								}
								if (column.property == 'month') {
									value += '月'
								}
								if (column.property == 'day') {
									value += '日'
								}
								return <el-link style="font-size:12px;" type="primary" onClick={()=>{this.detail(row,column)}} >{value}</el-link>
							}
						}
					}
				})
				gridOptions.pagerConfig.enabled = false
				gridOptions.scrollY = {
					enabled: false
				}
			},
			spanMethod({
				row,
				_rowIndex,
				column,
				visibleData
			}) {
				const fields = ['year', 'quarter', 'month', 'day', 'invoicecompany', 'invoiceattr']
				const cellValue = row[column.property]
				if (cellValue && fields.includes(column.property)) {
					const prevRow = visibleData[_rowIndex - 1]
					let nextRow = visibleData[_rowIndex + 1]
					if (prevRow && prevRow[column.property] === cellValue) {
						return {
							rowspan: 0,
							colspan: 0
						}
					} else {
						let countRowspan = 1
						while (nextRow && nextRow[column.property] === cellValue) {
							nextRow = visibleData[++countRowspan + _rowIndex]
						}
						if (countRowspan > 1) {
							return {
								rowspan: countRowspan,
								colspan: 1
							}
						}
					}
				}
			},
			detail(row, column) {
				this.detailconfig = {
					year: null,
					quarter: null,
					month: null,
				}
				for (let i in this.detailconfig) {
					this.detailconfig[i] = row[i]
					if (i == column.property) {
						break
					}
				}
				this.detailconfig.system = {
					customReport: 1
				}
				return new Promise(resolve => {
					this.detailloading = true
					this.detailShow = true
					this.$api.report.reportlist(this.reportName, this.detailconfig).then((res) => {
						this.detailData = res.list
						this.detailloading = false
						resolve()
					}, () => {
						this.detailloading = false
						resolve()
					})
				})

			},
			export() {	
				let text = document.getElementsByClassName('vxe-table')[0]
				let selection = window.getSelection()
				let range = document.createRange()
				range.selectNodeContents(text)
				selection.removeAllRanges()
				selection.addRange(range)
				document.execCommand('copy')
				selection.removeAllRanges()
				this.$message.success('复制成功')
				// this.$refs[this.reportName + '_list'].exportData({
				// 	filename: '测试',
				// 	type:'xlsx',
				// 	mode:'current',
				// 	remote:false,
				// 	style:true,
				// 	useStyle:true,
				// 	exportMethod:()=>{}
				// })
			}
		},
		components: {
			exportTable
		}
	}
</script>
